import type {OrgRepositoryPickerSelection} from '@github-ui/item-picker/OrgRepositoryPicker'

/**
 * Org login for the account-issue route (/orgs/:org/issues/:number), or undefined to use the
 * default repository navigation. The org picker only lists account_issues enrolled orgs, so an
 * `org` selection already implies enrollment.
 */
export function resolveAccountIssueOrgLogin({
  createMore,
  orgRepoSelection,
}: {
  createMore: boolean
  orgRepoSelection: OrgRepositoryPickerSelection | undefined
}): string | undefined {
  if (createMore || orgRepoSelection?.kind !== 'org') return undefined
  return orgRepoSelection.organization.login
}
